import { render, staticRenderFns } from "./ScreeningDetailsSection.vue?vue&type=template&id=72a9b786"
import script from "./ScreeningDetailsSection.vue?vue&type=script&lang=js"
export * from "./ScreeningDetailsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports